import linkSiteDialog from './link-site-dialog.vue';

export default linkSiteDialog;
